import { object, number } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { makeZodValidate as makeValidate } from '@occc/ui-forms';

const monthlyPerformanceGoalPerStoreSchema = number({ required_error: IS_REQUIRED }).int(
  'Must be an integer',
);

const monthlyPerformanceGoalSchema = object({
  membersPerStore: monthlyPerformanceGoalPerStoreSchema,
  transactionsPerStore: monthlyPerformanceGoalPerStoreSchema,
});

export const validateMonthlyPerformanceGoal = makeValidate(monthlyPerformanceGoalSchema);
